import React from 'react'
import { connect } from 'react-redux'
import { Menu, Dropdown } from 'antd'
import axios from 'axios'
import styles from './style.module.scss'
import AuthAPI from 'services/login'
import { Link } from 'react-router-dom'
import Common from 'services/common'
import Conf from 'ui-config'
import blooCommandIcon from '../../../system/Auth/img/bloo-icon-white.svg'
import blooCommandIconPink from '../../../system/Auth/img/bloo-icon-pink.svg'

const BLOO_COMMAND_URL = Conf.HOST + Conf.LC_IP + '/lc/users/handoff/start'

@connect(({ settings, user }) => ({
  user,
  theme: settings.theme,
  primaryColor: settings.primaryColor,
}))
class ProfileMenu extends React.Component {
  state = {
    count: 7,
    logoutStatus: null,
    preURI: Common.getPreURI(),
    blooCommandHover: false,
  }

  componentDidMount() {
    // warm the hover icon so the first hover does not flash an empty image
    new Image().src = blooCommandIconPink
  }
  authLogout = () => {
    var ssid = localStorage.getItem('SSID')
    let input = {
      SSID: ssid,
    }
    var historyURL = localStorage.getItem('historyURL')
    localStorage.clear()
    sessionStorage.clear()
    localStorage.setItem('historyURL', historyURL)
    AuthAPI.invalidate({ SSID: ssid, clusterId: this.props.user.selectedCluster.clusterId }).then(
      response => {
        var data = response.data
        if (data.status === 'success') {
          this.setState({ logoutStatus: data.data })
        }
        if (data !== null) {
          this.setState({ logoutStatus: data.data })
        }
      },
    )
    AuthAPI.logout(JSON.stringify(input))
      .then(response => {
        var data = response.data
        if (data.status === 'success') {
          this.setState({ logoutStatus: data.data })
        }
        if (data !== null) {
          this.setState({ logoutStatus: data.data })
        }
      })
      .catch(err => {
        this.setState({ logoutStatus: 'success' })
        var historyURL = localStorage.getItem('historyURL')
        localStorage.clear()
        sessionStorage.clear()
        localStorage.setItem('historyURL', historyURL)
      })
  }

  switchDarkTheme = () => {
    document.getElementById('user-menu').parentNode.classList.add('show-dropdown')
    const { dispatch } = this.props
    dispatch({ type: 'settings/TOGGLE_THEME' })
    setTimeout(() => {
      document.getElementById('user-menu').parentNode.classList.remove('ant-dropdown-hidden')
    }, 300)
  }

  logout = e => {
    e.preventDefault()
    const { dispatch } = this.props
    dispatch({
      type: 'user/SET_STATE',
      payload: {
        id: '',
        name: '',
        role: '',
        email: '',
        avatar: '',
        authorized: false,
        licenseType: '',
        loading: false,
        eulaStatus: false,
      },
    })
    localStorage.removeItem('payload')
    localStorage.removeItem('historyURL')
    // localStorage.setItem('historyURL','null')
    dispatch({
      type: 'user/LOGOUT',
      payload: {
        ssid: localStorage.getItem('SSID'),
        clusterId: this.props.user?.selectedCluster?.clusterId,
      },
    })
  }

  addCount = () => {
    let { count } = this.state
    count += 1
    this.setState({
      count,
    })
  }

  handleBlooCommandClick = e => {
    e.preventDefault()
    axios
      .get(BLOO_COMMAND_URL, {
        headers: {
          SSID: localStorage.getItem('SSID'),
        },
      })
      .then(response => {
        const redirectUrl = response.data.data.redirect_url
        var externalAppWindow = window.open(redirectUrl, '_self')
        this.setState({ externalAppWindow })
      })
      .catch(() => {
        Common.showNotifications('error', 'Unable to switch to Bloo Command right now')
      })
  }

  componentDidUpdate() {
    // if (this.props.theme === 'light') {
    //   this.switchDarkTheme()
    // }
  }

  render() {
    var email = localStorage.getItem('email')
    const menu = (
      <Menu selectable={false} id="user-menu">
        <Menu.Item style={{ cursor: 'default' }}>
          <div>
            <strong>User</strong>
            <br />
            {email}
          </div>
        </Menu.Item>
        <Menu.Divider />

        <Menu.Item>
          <div
            onMouseEnter={() => this.setState({ blooCommandHover: true })}
            onMouseLeave={() => this.setState({ blooCommandHover: false })}
            onFocus={() => this.setState({ blooCommandHover: true })}
            onBlur={() => this.setState({ blooCommandHover: false })}
          >
            <img
              src={this.state.blooCommandHover ? blooCommandIconPink : blooCommandIcon}
              alt=""
              className={styles.blooIcon}
            />
            &nbsp;&nbsp;
            <a href={BLOO_COMMAND_URL} onClick={this.handleBlooCommandClick}>
              Bloo Command (Beta)
            </a>
          </div>
        </Menu.Item>

        <Menu.Item>
          <div>
            <i className="fal fa-key mr-2"></i>&nbsp;&nbsp;
            <Link to={this.state.preURI + '/change-password'}>Change Password</Link>
          </div>
        </Menu.Item>

        <Menu.Item>
          <div onClick={this.logout}>
            <i className="fal fa-sign-out mr-2"></i>&nbsp;&nbsp; Logout
          </div>
        </Menu.Item>
      </Menu>
    )
    return (
      <Dropdown
        overlay={menu}
        trigger={['click']}
        onVisibleChange={this.addCount}
        placement="bottomRight"
      >
        <div className={styles.dropdown}>
          <i style={{ fontSize: '1rem' }} className="fal fa-user" />
        </div>
      </Dropdown>
    )
  }
}

export default ProfileMenu
